import React, { Component } from 'react';
import { NavMenu } from './NavMenu';

export class AuthorisedLayout extends Component {
    static displayName = AuthorisedLayout.name;

    render() {
        return (
            <div>
                <div className="wrapper">
                    <NavMenu />
                    {this.props.children}
                </div>
                <footer className="main-footer">
                    <strong>Copyright © 2020 <a href="https://www.utwiz.com/">UTWiz</a>.</strong> All rights reserved.
                </footer>
            </div>
        );
    }
}